'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'image';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f03e';
var svgPathData = ['M0 32l0 448 448 0 0-448-448 0zM48 416l96-144 46.1 69.1 81.9-133.1 128 208-352 0zM176 160a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z', 'M400 416L272 208 190.1 341.1 144 272 48 416 400 416z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faImage = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;